module.exports = __webpack_public_path__ + "img/westendoverlookfireworks_thumb.5c4d6b44.jpg";